import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib';
import { EquipamientoLaboratorio } from '../entity-equipamientos-laboratorio/equipamientos-laboratorio.model';
import { TipoEquipamientoLaboratorio } from './tipos-equipamiento-laboratorio.model';

export const entityTipoEquipamientoLaboratorioAdapter: EntityAdapter<TipoEquipamientoLaboratorio> =
  createEntityAdapter<TipoEquipamientoLaboratorio>({
    selectId: (model) => model.id,
    sortComparer: (a: TipoEquipamientoLaboratorio, b: TipoEquipamientoLaboratorio): number =>
      b.id.toString().localeCompare(a.id.toString())
  });

export interface EntityTipoEquipamientoLaboratorioState extends EntityState<TipoEquipamientoLaboratorio> {
  isLoading?: boolean;
  hasAddedSuccess?: boolean;
  error?: Error | null;
}

export const initialState: EntityTipoEquipamientoLaboratorioState =
  entityTipoEquipamientoLaboratorioAdapter.getInitialState({
    hasAddedSuccess: false,
    isLoading: false,
    error: null
  });
